// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"cf90087e","161":"76b0014f"}[chunkId] + ".chunk.js";
};